import { Component } from 'react';

class RenderIf extends Component {
  render() {
    if (this.props.if) {
      return this.props.children;
    }

    return null;
  }
}

export default RenderIf;



// WEBPACK FOOTER //
// ./src/app/shared/render-if/components/render-if.js